'use strict';

/**
 * Replaces the 'cgid=root' parameter in a URL with 'cgid={categoryId}'.
 *
 * @param {string} url - The URL string to modify.
 * @param {string} categoryId - The category ID to replace 'root' with.
 * @returns {string} The updated URL with the new category ID, or the original URL if no replacement was made.
 */
function replaceRootCategoryInURL(url, categoryId) {
    if (url && url.length && url.includes('cgid=root')) {
        return url.replace('cgid=root', 'cgid=' + categoryId);
    }

    return url;
}

/**
 * Applies the current sorting rule to the provided URL by appending it as a query parameter.
 * 
 * @param {string} url - The URL to which the sorting rule should be applied
 * @returns {string} The URL with the sorting rule appended as 'srule' parameter, or the original URL if no sorting rule is selected or URL is invalid
 */
function applyCurrentSortingRule(url) {
    if (url && url.length) {
        const selectedSortingRule = $('select[name="sort-order"] option:selected');
        const currentSortingRule = selectedSortingRule && selectedSortingRule.length && selectedSortingRule.attr('class');
        if (currentSortingRule) {
            // Check if srule already exists in the URL
            if (url.includes('srule=')) {
                // Replace existing srule value
                return url.replace(/srule=[^&]*/, 'srule=' + currentSortingRule);
            } else {
                // Append new srule parameter
                const separator = url.includes('?') ? '&' : '?';
                return url + separator + 'srule=' + currentSortingRule;
            }
        }
    }
    return url;
}

/**
 * filter apply handler and ajax request
 *
 * @param {*} event - Slider event
 * @param {Object} $el - jQuery DOM element
 * @param {Function} parseResults - Callback function
 */
function send(event, $el, parseResults) {
    event.preventDefault();
    event.stopPropagation();

    $.spinner().start();
    $el.trigger('search:filter', event);

    var searchUrl = $el.data('href');
    var seoUrl = $el.data('seo-href') || searchUrl;

    if ($el.hasClass('category-button')) {
        var categoryId = $el.data('category-id');
        // Prevets refining by root category when clicking on a category filter
        searchUrl = replaceRootCategoryInURL(searchUrl, categoryId);
        seoUrl = replaceRootCategoryInURL(seoUrl, categoryId);
    }

    searchUrl = applyCurrentSortingRule(searchUrl);
    seoUrl = applyCurrentSortingRule(seoUrl);

    if (seoUrl) {
        window.history.pushState({}, null, seoUrl);
    }

    var attributeId = '#' + $el.find('span').last().attr('id');

    $.ajax({
        url: searchUrl,
        data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: searchUrl
        },
        method: 'GET',
        success: function (response) {
            parseResults(response);
            $.spinner().stop();
            $(attributeId).parent('button').focus();
        },
        error: function () {
            $.spinner().stop();
            $(attributeId).parent('button').focus();
        }
    });
}

module.exports = {
    send
}